import { parseSearchMask, hasOwnSearchArea } from '../imcmd/SearchMask.js';

/**
 * Базовый класс для провайдеров серверных команд.
 *
 * Даёт типизированный контракт и общие хелперы,
 * которые упрощают разработку новых провайдеров.
 */
class ServerCmdProviderBase {
    /**
     * Хелпер для формирования SearchMask (учитывает area и tableMode).
     * @param mask Строка маски
     * @param area Область, присланная отдельным полем команды (подмешивается как ^area)
     * @param tableMode Включить режим таблицы
     * @returns Разобранный объект SearchMask либо undefined
     */
    makeMask(mask, area, tableMode = false) {
        const expr = this.makeMaskStr(mask, area);
        if (!expr)
            return undefined;
        return parseSearchMask(expr, tableMode);
    }
    /**
     * Хелпер для добавления зоны к маске.
     *
     * Зона, присланная отдельным полем, приклеивается только к маске без собственной зоны:
     * суффикс `^area` у самой маски конкретнее внешнего значения и побеждает его. Иначе в строке
     * оказалось бы два `^`, разбор взял бы внешнюю зону, а остаток с `^` ушел бы в селектор и
     * сделал его невалидным.
     *
     * @param mask Строка маски
     * @param area Область, присланная отдельным полем команды (подмешивается как ^area)
     * @returns Строка поиска либо undefined, если маска не задана
     */
    makeMaskStr(mask, area) {
        if (!mask)
            return undefined;
        return area && !hasOwnSearchArea(mask) ? `${mask}^${area}` : mask;
    }
    /**
     * Хелпер для возврата результата адаптации.
     * Удобен для провайдеров, чтобы не собирать вручную объект AdaptResult.
     *
     * @param tokens Сгенерированные токены
     * @param consumed Если true — остальные провайдеры не вызываются
     */
    makeResult(tokens, consumed = false) {
        return { tokens, consumed };
    }
    /**
     * Доработка токенов: добавляем mask или targetItems при необходимости.
     *
     * @param cmd  исходная серверная команда
     * @param ctx  контекст выполнения
     * @param res  результат адаптации (список токенов)
     */
    finalizeTokens(cmd, ctx, res) {
        if (!res?.tokens?.length)
            return;
        for (const t of res.tokens) {
            if (typeof t === "string")
                continue; // строковые токены не трогаем
            if (t.targetMask || (t.targetItems && t.targetItems?.length > 0))
                continue; // маска уже задана или целевые элементы определены
            const mask = this.makeMask(cmd.mask, cmd.area, !!cmd.tableMode);
            if (mask) {
                t.targetMask = mask;
            }
            else {
                t.targetItems = [ctx.viewHost];
            }
        }
    }
}

export { ServerCmdProviderBase };
